import { HeroHeader } from "./components/HeroHeader";
import landing1 from "../../assets/landing_1.png";
import landing3 from "../../assets/landing_3.png";
import landing4 from "../../assets/landing4.png";
import landing0 from "../../assets/landing0.png";
import profileLandingImage from "../../assets/profile_landing.png";
import interactiveResumeImage from "../../assets/interactive_resume_landing.png";
import landingBottom from "../../assets/landing_footer.png";
import { LoadingSpinner } from "../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignIn } from "@fortawesome/free-solid-svg-icons";
import { LeadButton } from "../dashboard/home/components/LeadButton";
import { useAuth0 } from "@auth0/auth0-react";
import { MovingOne } from "./components/MovingOne";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

export const Component = () => {
  const { loginWithRedirect, isAuthenticated, isLoading, user } = useAuth0();
  const navigate = useNavigate();
  const [redirectAttempt, setRedirectAttempt] = useState(0);

  useEffect(() => {
    // Don't do anything while Auth0 is still loading
    if (isLoading) {
      return;
    }

    if (
      (isAuthenticated && user) ||
      window.location.href.indexOf("localhost") !== -1
    ) {
      navigate("/auth"); // or whatever URL you want to redirect to
      setRedirectAttempt(0); // Reset attempts if user authenticates
    } else {
      const authToken = localStorage.getItem("profile-auth-token");
      if (!authToken) {
        // If no token exists, skip retry mechanism and redirect directly
        window.location.href = "https://start.voc.studio";
      } else {
        if (redirectAttempt < 5) {
          const timer = setTimeout(() => {
            setRedirectAttempt((prevAttempts) => prevAttempts + 1);
          }, 1000); // Wait 1 second before trying again

          return () => clearTimeout(timer); // Cleanup timer on unmount or if dependencies change
        } else {
          window.location.href = "https://start.voc.studio";
        }
      }
    }
  }, [isAuthenticated, isLoading, user, navigate, redirectAttempt]);

  return (
    <div className="min-h-[100%] h-[100%] flex items-center justify-center">
      <LoadingSpinner size="large" />
    </div>
  );
};

Component.displayName = "LandingPage";

export default Component;
